import { render } from "./Portfolios.vue?vue&type=template&id=6921df0d"
import script from "./Portfolios.vue?vue&type=script&lang=js"
export * from "./Portfolios.vue?vue&type=script&lang=js"

import "./Portfolios.vue?vue&type=style&index=0&id=6921df0d&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__